(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('quickSidebar', [QuickSidebarFn]);

    /* main quick sidebar directive */
    function QuickSidebarFn() {
        var directive = {
            restrict: 'E',
            templateUrl: '/app/ringfoon/templates/quick-sidebar.template.html'
        };
        return directive;
       
    }

})();